<template>
  <div :class="styles.bgPage[globalStyles.bgPage]" class="px-4 py-8">
    <div
      class="hidden mx-auto overflow-hidden page md:block print:block"
      size="A4"
    >
      <simple-layout :globalStyles="globalStyles"></simple-layout>
    </div>
    <div
      class="w-full sm:hidden print:hidden mx-auto h-test2"
      style="max-height: 472px; max-width: 334px; min-height: calc(100vh)"
    >
      <div style="max-height: 472px; max-width: 334px">
        <div class="scaled page overflow-hidden origin-top-left">
          <simple-layout :globalStyles="globalStyles"></simple-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleLayout from "@/components/cvTemplates/SimpleLayout";
import datos from "@/data/example.json";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    namejson: { required: true, type: String },
  },
  components: {
    SimpleLayout,
  },
  data() {
    return {
      globalStyles: datos.style,
    };
  },
  created() {
    // monto la informacion
    this.updateBasics(datos.basics);
    this.updateWork(datos.work);
    this.updateSkills(datos.skills);
    this.updateEducation(datos.education);
    this.updateIdioms(datos.idioms);
    this.updateOtherData(datos.otherData);
    this.updateProyects(datos.projects);
    this.updateControl(datos.control);
    this.updateInterests(datos.interests);
    this.updateReferences(datos.references);
    this.updateBioinfo({
      image: "/assets/random-user.jpg",
    });
  },
  computed: {
    ...mapState("style", ["styles"]),
  },
  methods: {
    ...mapActions([
      "updateWork",
      "updateSkills",
      "updateEducation",
      "updateBasics",
      "updateIdioms",
      "updateOtherData",
      "updateProyects",
      "updateControl",
      "updateInterests",
      "updateBioinfo",
      "updateReferences",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: white;

  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.page[size="A4"] {
  width: 21cm;
  height: 29.699cm;
}
@media (max-width: 600px) {
  .scaled {
    width: 21cm;
    height: 29.699cm;
    -ms-transform: scale(0.42);
    -moz-transform: scale(0.42);
    -o-transform: scale(0.42);
    -webkit-transform: scale(0.42);
    transform: scale(0.42);
  }
  .scaled::after {
    max-height: 100px;
  }
}
</style>